import { createSelector } from 'reselect'

const select = (state) => state.home

const selectLayout = createSelector(select, (home) => home.layout)

export { selectLayout }
